import React, { useState, useCallback, useEffect } from "react";
import { ProductSuggestionModel } from "../../../tsrestapi/models";
import TranslateManager from 'ts-translate-js';
import { DecimalInput } from "../../atoms/decimal-input";
import './product-suggestion.scss';
import { PleaseWaitSpinner } from "../../../../jsxctl/utilctl";

const tr = TranslateManager.boundTR;

type ProductSuggestionProps = {
    productSuggestion: ProductSuggestionModel,
    onAddProduct: (eventId: number, amount: number) => void,
    cartResponse: any
};

export function ProductSuggestion({ productSuggestion, onAddProduct, cartResponse }: ProductSuggestionProps) {
    const [productAmount, setProductAmount] = useState(0);
    const [disableButton, setDisableButton] = useState(false);
    const [inProcess, setInProcess] = useState(false);
    const [productAdded, setProductAdded] = useState(false);

    useEffect(() => {
        setProductAmount(productSuggestion.suggestedPrice);
    }, [productSuggestion, setProductAmount]);

    useEffect(() => {
        if(cartResponse){
            if(cartResponse.IsSuccess) {
                setProductAdded(true);
            }

            if(cartResponse.cartUpdated){
                setProductAdded(false);
                setDisableButton(false);
            }

            setInProcess(false);
        }
    }, [cartResponse, setProductAdded, setDisableButton, setInProcess]);

    const handleOnProductAdded = useCallback(() => {
        setInProcess(true);
        onAddProduct(productSuggestion.eventId, productAmount);
    }, [productAmount, productSuggestion, setInProcess, onAddProduct]);

    const handleFixedAmountChange = useCallback((value: number) => {
        const isValid = value > 0 && !isNaN(value);
        if(isValid)
            setProductAmount(value);
        setDisableButton(!isValid);
    }, [setDisableButton, setProductAmount]);

    const cSur = tsapp.getCurrencySurrounding();

    const productTitle = productSuggestion.title[tsapp.twoLetterLang];
    const productDescription = productSuggestion.description[tsapp.twoLetterLang];

    return <div>
        <div className="product-suggestion">
            {
                productSuggestion.pictureURl &&
                        <div className="image" style={{backgroundImage: `url(${productSuggestion.pictureURl})`}}/>
            }
            <div className="content">
                <div className="product-header">
                    <h4 style={{margin:"0px"}}>{productTitle}</h4>
                    {productDescription != productTitle && <p>{productDescription}</p>}
                </div>
                {inProcess ? <PleaseWaitSpinner /> :
                <div className="input">
                    {productAdded 
                        ? <h3 style={{margin: 0}}>{tr("Merci !")}</h3>
                        : <>
                            <span>
                                <span>{tr("Montant") + tr(":")} </span>
                                <span>{cSur.before}</span>
                                <DecimalInput id="productAmount" name="productAmount" value={productAmount} onChange={handleFixedAmountChange} />
                                <span>{cSur.after}</span>
                            </span>
                            <div>
                                <input type="button" disabled={disableButton} className="btn btn-xs btn-info" value={productSuggestion.alreadyInCart ? tr("Modifier") : tr("Ajouter")} onClick={handleOnProductAdded} />
                            </div>
                        </>}
                </div>}
            </div>
        </div>
        <hr />
    </div>;
}